// Source labels for book search results (Algolia catalog vs external providers).
// Extracted from BookSearchField.svelte so importing this runtime value does not
// drag the whole .svelte component into the shell/search chunk graph.
export const SOURCE_LABELS: Record<string, { label: string; color: string }> = {
  google_books: {
    label: 'Google',
    color:
      'bg-primary-100 text-primary-800 dark:bg-primary-900 dark:text-primary-300',
  },
  database: {
    label: 'Catalog', // OR `Indexed` I'm a lil split here.
    color:
      'bg-warning-100 text-warning-900 dark:bg-warning-900 dark:text-warning-200',
  },
}
